<template>
  <div class="footer-container">
    <div class="footer-main">
      <p class="footer-title">联系我们</p>
      <div class="footer-info">
        <div class="footer-info-item">
          <img src="../../assets/img/dz.png" alt="">
          <span>联系地址：{{ contact.addr }}</span>
        </div>
        <div class="footer-info-item">
          <img src="../../assets/img/dh.png" alt="">
          <span>联系电话：{{ contact.tel }}</span>
        </div>
      </div>
      <div class="footer-copyright">
        <div>{{ contact.copyright }}</div>
        <div>
          <img src="../../assets/img/ga_tb.png" alt="">
          <span>{{ contact.recordNo }}</span>
        </div>
      </div>
      <div class="footer-qrcode" :style="{backgroundImage: `url(${$assetsPath + contact.imgUrl})`}"></div>
    </div>
  </div>
</template>

<script>
import { getContact } from '@/api'

export default {
  data() {
    return {
      contact: {}
    }
  },
  mounted() {
    getContact().then(res => {
      this.contact = res.data
    })
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  background: #102E60;
  color: #fff;
  .footer-main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    position: relative;
    .footer-title {
      font-size: 28px;
      font-weight: bold;
      line-height: 24px;
      border-left: 4px solid #0077FE;
      padding: 0 12px;
    }
    .footer-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 30px;
      .footer-info-item {
        font-size: 20px;
        line-height: 24px;
        margin-right: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 15px;
        }
      }
    }
    .footer-copyright {
      margin-top: 60px;
      padding: 30px 0;
      text-align: center;
      font-size: 16px;
      line-height: 26px;
      border-top: 1px solid rgba(#fff, 0.3);
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 10px;
        }
      }
    }
    .footer-qrcode {
      position: absolute;
      top: 40px;
      right: 0;
      width: 121px;
      height: 121px;
      background-size: cover;
      background-position: center center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue